/* globals jQuery */
import 'fancybox/dist/js/jquery.fancybox.js';
import 'fancybox/dist/helpers/js/jquery.fancybox-thumbs.js';

(function(document, $) {
    const fancyBoxArray = [];

    function openFancyBox(e){
        $.fancybox.open(fancyBoxArray, {
        index: e.data.imgTarget,
        openEffect: 'elastic',
        autoScale: true,
        beforeShow: function () {
            $(".fancybox-image").attr("alt", this.alt);
        },
        helpers : {
            thumbs : {
            width: 50,
            height: 50
            }
        }
        });
    }

    $(document).ready(function() {  
        $(".fancybox, .fancybox-home").each(function (i) {
            var fancyBoxObject = {};
            fancyBoxObject.href = this.src;
            fancyBoxObject.title = this.title;
            fancyBoxObject.alt = this.alt;
            fancyBoxArray.push(fancyBoxObject);
            $(this).on('click', {imgTarget: i}, openFancyBox);
        });
    });

}(document, jQuery));
